export default {
    divider: {
        borderRight: "1px solid #D4D6D7",
        width: "1px",
        height: "18px"
    },
}